import React from 'react'
import classNames from 'classnames'
import { FetcherList } from '@garpix/fetcher/fetcher-list/react-router'
import { dataStates } from '@garpix/fetcher'
import { IFetcherListResults } from '@/interfaces/Fetcher'
import Button from '@/components/Button'
import Container from '@/components/Container'
import ContestCard from '@/components/Cards/ContestCard'
import Section from '@/components/Section'
import Title from '@/components/Title'
import { PlaceholderLoading } from '@/components/PlaceholderLoading'
import style from './styles/contests.module.scss'
import { api } from '@/api'

interface IProps {
  title?: string
  titleStyle?: string
}

const Contests = ({
  title = 'Конкурсы',
  titleStyle = ''
}: IProps): React.ReactElement => {
  return (
    <Section>
      <FetcherList
        initFilter={{ page_size: 4 }}
        isScrollTop={false}
        isHistoryPush={false}
        api={api.getContests}
      >
        {({
          results,
          status,
          showMore,
          isNext
        }: IFetcherListResults<any[]>) => {
          return (
            <Container>
              <Title
                type='h2'
                theme='h1'
                className={classNames({
                  [style.contests__title]: true,
                  [style[`contests__title--${titleStyle}`]]:
                    Boolean(titleStyle)
                })}
              >
                {title}
              </Title>
              {results?.length > 0
                ? (
                  <ul>
                    {results.map((el) => {
                      console.log(el, 'el')
                      return (
                        <li key={el.id} className={style.contests__item}>
                          <ContestCard
                            id={el.id}
                            image={el.preview_picture?.[0] ?? ''}
                            title={el.name}
                            theme={el.property_topic_value}
                            date={el.active_from}
                          />
                        </li>
                      )
                    })}
                  </ul>
                  )
                : null}
              <div>
                {status === dataStates.loading
                  ? (
                    <div>
                      <PlaceholderLoading
                        shape='rect'
                        width='100%'
                        height='230px'
                      />
                    </div>
                    )
                  : null}
              </div>

              {isNext
                ? (
                  <Button
                    disabled={status === dataStates.loading}
                    size='large'
                    wide
                    outline
                    className={style.contests__more}
                    onClick={showMore}
                  >
                    Еще конкурсы
                  </Button>
                  )
                : null}
            </Container>
          )
        }}
      </FetcherList>
    </Section>
  )
}

export default Contests
